import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Input, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useRef } from "react";
import { useState } from "react";
import policyService from "../../services/policyService.js";

const PolicyAuditorModal = (props) => {

	const policyId = useRef(null);
	const email = useRef(null);
	const [ loading, setLoading ] = useState(false);
	
	const handleSubmitForm = async (e) => {
		e.preventDefault();
		setLoading(true);
		await policyService.auditPolicy(policyId.current.value, email.current.value);
		handleClose();
		setTimeout(() => {
			setLoading(false);
		}, 500);
	};
	
	const handleClose = () => {
		props.onClose()
	};
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	return (
		<Dialog
			open={props.open? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="sm"
		>
			<DialogTitle id="alert-dialog-title">
				Share Policy With Auditor
			</DialogTitle>
			<DialogContent>
				{ loading &&
					<Box sx={{ textAlign: "center", marginTop: "3em", marginBottom: "1em" }}>
						<CircularProgress sx={{ margin: "auto", textAlign: "center" }} />
					</Box>
				}
				{ !loading &&
					<form id="policyForm" onSubmit={handleSubmitForm} autoComplete="off">
						<FormControl sx={formControlStyle}>
							<InputLabel htmlFor="policy" sx={{ backgroundColor: "background.inputLabel" }}>
								Policy
							</InputLabel>
							<Select
								inputRef={policyId}
								id="policy"
								disableUnderline="true"
								defaultValue={policyService.companyPolicies.length > 0?
									policyService.companyPolicies[0].id : ""
								}
							>
								{ policyService.companyPolicies.map((policy, i) => {
									return (
										<MenuItem key={`policy_${i}`} value={policy.id}>{`${policy.name}`}</MenuItem>
									);
								})}
							</Select>
						</FormControl>
						<FormControl sx={formControlStyle}>
							<InputLabel htmlFor="name">Auditor's Email Address</InputLabel>
							<Input
								inputRef={email}
								id="email"
								type="text"
								autoComplete="off"
								defaultValue=""
							/>
						</FormControl>
					</form>
				}
			</DialogContent>
			{ !loading &&
				<DialogActions>
					<Button onClick={handleClose}>Cancel</Button>
					<Button type="submit" form="policyForm" autoFocus>Submit</Button>
				</DialogActions>
			}
		</Dialog>
	);

}

export default PolicyAuditorModal;